import { render, staticRenderFns } from "./junction-box-details-form.component.vue?vue&type=template&id=468accf8"
import script from "./junction-box-details-form.component.ts?vue&type=script&lang=ts&external"
export * from "./junction-box-details-form.component.ts?vue&type=script&lang=ts&external"
import style0 from "./junction-box-details-form.component.vue?vue&type=style&index=0&id=468accf8&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('468accf8')) {
      api.createRecord('468accf8', component.options)
    } else {
      api.reload('468accf8', component.options)
    }
    module.hot.accept("./junction-box-details-form.component.vue?vue&type=template&id=468accf8", function () {
      api.rerender('468accf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/junction-box-details-form/junction-box-details-form.component.vue"
export default component.exports